export default {"src":"https://images-cdn-staging.curipod.com/d-44b2e202/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};